import { httpRequest } from './../../util/Helper.js';
import { ALCHEMISTEN } from 'da-three';

import React, {Component} from 'react';
import Customer from './customer.component';
import ParameterButton from './parameter-button.component';
import ToggleButton from './toggle-button.component';
import Login from './../../login/components/login.component';

export default class Overview extends Component {
        
    constructor() {
        super();
        
        this.i18n = ALCHEMISTEN.instance.i18n;
        this.auth = ALCHEMISTEN.instance.auth;
        this.customerKey = window.location.pathname.replace(/\/?$/, "").split("/").reverse()[0];
        this.apiBase = process.env.API_BASE.replace(/\/$/, "");
        
        this.texts = {
            base: window.location.origin+'/',
            iframeStart: '<iframe allowfullscreen="true" scrolling="no" src="',
            iframeWidth: '" style="width:"',
            iframeHeight: '; height: ',
            iframeEnd: ';"></iframe>',
        };
        
        this.parameters = {
            embed: {
                code: 'e',
                text: 'Vorgeschalteter Play Button'
            },
            logo: {
                code: 'l',
                text: 'Alchemisten Logo'
            },
            scroll: {
                code: 's',
                text: 'Zoomen aktiv'
            },
            transparent: {
                code: 't',
                text: 'Transparenter Hintergrund'
            },
        }
        
        this.state = {
            code: '',
            selected: null,
            customers: [],
            iframe: true,
            width: '750px',
            height: '450px',
            parameters: {
                embed: 1,
                logo: 0,
                scroll: 2,
                transparent: 2
            },
            sideOpen: false,
            language: 'none',
            loggedIn: this.auth.isLoggedIn
        };
    }
    
    componentDidMount(){
        this.loadTranslations();
        this.loadData();
        this.constructCode();
    }
    
    constructCode(){
        let code = 'Bitte wählen Sie ein Produkt aus!';
        if (this.state.selected !== null){   
            code = this.texts.base + 'view/' + this.state.selected.key;
            let pCount = 0;
            Object.entries(this.state.parameters).forEach(([key, value]) => {
                if (value < 2){
                    if (pCount === 0){
                        code += '?';
                    } else {
                        code += '&';
                    }
                    pCount++;
                    code += this.parameters[key].code+'=';
                    if (value === 1) {
                        code += 'true';
                    } else {
                        code += 'false';
                    }
                }
            });
            if (this.state.language !== 'none'){
                if (pCount > 0){
                    code += '&';
                } else {
                    code += '?';
                }
                code += 'lng='+this.state.language;
            }

            if (this.state.iframe){
                code = this.texts.iframeStart + code 
                        + this.texts.iframeWidth + this.state.width
                        + this.texts.iframeHeight + this.state.height
                        + this.texts.iframeEnd;
            }
        }
        
        this.setState({code: code});
    }
    
    copyToClipboard(){
        let textArea = document.createElement("textarea");
        textArea.value = this.state.code;
        document.body.appendChild(textArea);
        textArea.select();
        try {
            var successful = document.execCommand('copy');
            if (successful) {
                alert("Code in die Zwischenablage kopiert!");
            } else {
                alert("Fehler! Code konnte nicht kopiert werden.");
            }
        } catch (err) {
            alert("Fehler! Code konnte nicht kopiert werden.");
        }

        document.body.removeChild(textArea);
    }
    
    loadData(){
        let customers = [];

        let requestURL = this.apiBase+'/customer/projects/';
        if (this.customerKey === ''){
            requestURL += 'all';
        } else {
            requestURL += this.customerKey;
        }
        this.auth.authorizedRequest(requestURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, (data) => {
            if (data.payload !== undefined) {
                customers = data.payload;
            }
            this.setState({customers: customers, loggedIn: this.auth.isLoggedIn});
        }, (progress) => {

        });
    }
    
    loadTranslations(){
        httpRequest(this.apiBase+'/translation', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }, (data) => {
            this.i18n.register(data.payload);
        });
    }
    
    logout(){
        this.auth.logout();
        this.setState({loggedIn: this.auth.isLoggedIn});
    }
        
    selectObject(project){
        let select = null;
        if (this.state.selected === null || this.state.selected.key !== project.key){
            select = project;
        }
        let lang = this.state.language;
        if (select === null || select.languages.indexOf(this.state.language) === -1){
            lang = 'none';
        }
        this.setState({selected: select, language: lang},() => {
            this.constructCode();
            if ((!this.state.sideOpen && this.state.selected !== null) || (this.state.sideOpen && this.state.selected === null)) {
                this.toggleSide();
            }
        });
    }
    
    setParameter(name,value){
        let params = {...this.state.parameters};
        params[name] = value;
        this.setState({parameters: params},this.constructCode);
    }
    
    setIframeWidth(event) {
        this.setState({width: event.target.value},this.constructCode);
    }
    
    setIframeHeight(event) {
        this.setState({height: event.target.value},this.constructCode);
    }
    
    setLanguage(event) {
        this.setState({language: event.target.value},this.constructCode);
    }
    
    toggleIframe(){
        this.setState({iframe: !this.state.iframe},this.constructCode);
    }
    
    toggleSide(){
        this.setState({sideOpen: !this.state.sideOpen});
    }
    
    
    
    render(){
        return(
            <div>
                <header id="page-header" className="no-select">
                    <h1>3D Dashboard</h1>
                    <div id="logo">
                        {this.state.customers.length !== 1 && 
                        <a href="https://www.alchemisten.de" target="_blank">
                            <img src={this.texts.base+'app/img/logo-alchemisten-badge.png'} alt={'DIE ALCHEMISTEN AG Logo'} />
                        </a>
                        }
                        {this.state.customers.length === 1 && this.state.customers[0].logo !== '' && 
                        <img src={this.texts.base+'static/projects/'+this.state.customers[0].key+'/'+this.state.customers[0].logo} alt={this.state.customers[0].name+' Logo'} />
                        }
                    </div>
                    {(this.customerKey !== '' || this.state.loggedIn) &&
                    <nav>
                        <button type="button" id="side-btn" onClick={() => this.toggleSide()} title="Optionen anzeigen">
                            <img src={this.texts.base+'app/img/open-close-slide-icon.svg'} alt="Open close icon" />
                        </button>
                        
                        {(this.customerKey === '' && this.state.loggedIn) &&
                        <button type="button" id="logout-btn" onClick={() => this.logout()} title="Abmelden">
                            <img src={this.texts.base+'app/img/logout-icon.svg'} alt="Logout icon" />
                        </button>
                        }
                    </nav>
                    }
                </header>
    
                {(this.customerKey === '' && !this.state.loggedIn) &&
                <Login onSuccess={() => {this.setState({loggedIn: true},this.loadData());}}></Login>
                }
                
                {(this.customerKey !== '' || this.state.loggedIn) &&
                <div className={this.state.sideOpen?'':'side-closed'}>
                    {this.state.customers.length === 1 && this.state.customers[0].color !== '' &&
                    <style dangerouslySetInnerHTML={{__html: `
                        .btn.selected.customer-style,
                        aside .copy-btn:hover,
                        .view-link:hover { background-color: `+this.state.customers[0].color+` !important }
                      `}} 
                    />
                    }
                    
                    <main className="no-select">
                        {Object.entries(this.state.customers).map(([key,value]) => {
                            return (
                                <Customer 
                                    key={key}
                                    base={this.texts.base}
                                    customer={value}
                                    selectObject={(project) => this.selectObject(project)}
                                    selected={this.state.selected}
                                    headline={this.state.customers.length>1}
                                />
                            );
                        })}
                    </main>

                    <aside>
                        <header className="no-select">
                            <h2>Code</h2>
                            <p>
                                Konfigurieren und Kopieren Sie diesen Code, um Ihr Produkt
                                per iFrame einzubetten oder zu verlinken.                        
                            </p>
                        </header>

                        <pre id="word-wrap">
                            {this.state.code}
                        </pre>
                        {this.state.selected !== null && 
                        <button type="button" className="copy-btn no-select" onClick={() => this.copyToClipboard()}>Kopieren</button>
                        }

                        <div className="no-select">
                            <h3>Optionen</h3>
                            <ToggleButton 
                                text="iFrame Einbettung"
                                value={this.state.iframe}
                                onClick={() => this.toggleIframe()}
                            />
                            <label>
                                Breite
                                <input type="input" value={this.state.width} onChange={this.setIframeWidth.bind(this)} />
                            </label>
                            <label>
                                Höhe
                                <input type="input" value={this.state.height} onChange={this.setIframeHeight.bind(this)} />
                            </label>

                            {Object.entries(this.state.parameters).map(([key,value]) => {
                                return (
                                    <ParameterButton 
                                        key={key}
                                        id={key}
                                        text={this.parameters[key].text}
                                        value={value}
                                        onClick={(name,value) => this.setParameter(name,value)}
                                    />
                                );
                            })}

                            {this.state.selected !== null && this.state.selected.languages.length > 1 &&
                            <label>
                                Sprache
                                <select onChange={this.setLanguage.bind(this)} value={this.state.language}>
                                    <option value="none">Keine</option>
                                {Object.entries(this.state.selected.languages).map(([key,value]) => {
                                    return (
                                        <option key={key} value={value}>{this.i18n.translate('dastudio.'+value)}</option>
                                    );
                                })}
                                </select>
                            </label>
                            }
                        </div>
                    </aside>
                </div>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/js/overview/components/overview.component.js